import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { stripTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" aria-label="Testimonianze" data-id="element-237" data-mp="3sq1wvzm5442a">
      <div className="max-w-7xl mx-auto px-4" data-id="element-238" data-mp="3nzbo0cei9j2u">
        <div className="grid md:grid-cols-3 gap-6 items-stretch" data-id="element-239" data-mp="3nxiix1jjj6wy">
          {stripTestimonials.map((t, i) => <motion.figure key={`${t.role}-${i}`} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-black border border-gold/20 p-6 rounded-2xl flex flex-col h-full" data-id="element-240" data-mp="5nf5qst8iazd" data-mpi={i}>
              <div className="flex gap-1 text-gold mb-4" aria-hidden="true" data-id="element-241" data-mp="2cdwkmapyakmt">
                {[...Array(5)].map((_, j) => <StarIcon key={j} size={16} fill="currentColor" data-id="element-242" data-mp="geapixismng3" data-mpi={j} />)}
              </div>
              <blockquote className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-243" data-mp="lddwwom8x5r8">
                “{t.text}”
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-auto" data-id="element-244" data-mp="q4vxhbkcx4bo">
                <span className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold shrink-0" data-id="element-245" data-mp="v3qdk5qxwes3">
                  {t.initials}
                </span>
                <span data-id="element-246" data-mp="143ddso7xnejk">
                  <span className="block font-bold text-white text-sm" data-id="element-247" data-mp="1456pwj1beqyy">
                    {t.name}
                  </span>
                  <span className="block text-xs text-gold-light" data-id="element-248" data-mp="190vskv8msnzh">{t.role}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}